import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function PageNotFound() {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Kryzen Info</title>
        <meta
          name="description"
          content="The page you are looking for does not exist on Kryzen Info. Explore hydroponics news, agri-tech insights, and more."
        />
      
      </Helmet>

      <div className="container text-center py-8" >
        <h1 className="display-1 fw-bold text-green">404</h1>
        <p className="fs-2 mb-4">
          Oops! The page you’re looking for doesn’t exist.
        </p>
        <div>
          <Link to="/" className="btn btn-dark px-4 py-2">
            Go back to Homepage
          </Link>
        </div>
      </div>
    </>
  );
}
